export default "__VITE_ASSET__Crexf6qw__"